export enum URLIconEnum {
  WORKSHEET = 'WORKSHEET',
  DOWNLOAD = 'WORKSHEET',
  QUESTIONNAIRE = 'QUESTIONNAIRE',
  ARTICLE = 'ARTICLE',
  PERSONALMEETING = 'PERSONALMEETING',
  FACE2FACE = 'PERSONALMEETING',
  COMMUNITY = 'COMMUNITY',
  WHITEBOARD = 'WHITEBOARD',
  CHATBOT = 'CHATBOT',
  //ZOOM = 'VIDEOCALL',
  AUDIO = 'AUDIO',
  VIDEO = 'VIDEO',
  LINK = 'LINK',
  VIDEOCALL = 'VIDEOCALL',
  YOUTUBE = 'YOUTUBE',
  TWITTER = 'TWITTER',
  SLACK = 'SLACK',
  PDF = 'PDF',
  ZIP = 'ZIP',
  PRESENTATION = 'PRESENTATION',
  LINKEDIN = 'LINKEDIN',
  FACEBOOK = 'FACEBOOK',
  INSTAGRAM = 'INSTAGRAM',
  SKYPE = 'SKYPE',
  MSPOWERPOINT = 'MSPOWERPOINT',
  MSWORD = 'MSWORD',
  MSEXCEL = 'MSEXCEL',
  ZOOM = 'ZOOM',
  GOOGLESHEETS = 'GOOGLESHEETS',
  GOOGLEDOCS = 'GOOGLEDOCS',
  MSTEAMS = 'MSTEAMS',
}
